import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import {VENDOR_NAMES} from '@/constants/billingConstants';

const state = {
  filterData: {
    accounts: [
      "045665193992"
    ],
    products: [
      {
        code: "AmazonEC2",
        name: "EC2",
        parentCode: "SP_PRODUCT",
        codes: null
      }
    ],
    regions: [
      {
        code: "ap-northeast-2",
        name: "Asia Pacific (Seoul)",
        parentCode: "RGNCONVERT",
        codes: null
      }
    ],
    instanceFamilies: [
      "m5"
    ]
  },
  coverageList: {
    totalCount: 0,
    list: [
      {
        onDemandCost: 0.0,
        savingsPlansCost: 0.0,
        reservedOnDemandCost: 0.0,
        totalCost: 0.0,
        onDemandUsage: 0.0,
        reservedUsage: 0.0,
        savingsPlansUsage: 0.0,
        totalUsage: 0.0,
        totalUsageWithSp: 0.0,
        reservedCoverage: 0.0,
        reservedCoverageWithSp: 0.0,
        onDemandNfUsage: 0.0,
        reservedNfUsage: 0.0,
        savingsPlansNfUsage: 0.0,
        totalNfUsage: 0.0,
        totalNfUsageWithSp: 0.0,
        reservedNfCoverage: 0.0,
        reservedNfCoverageWithSp: 0.0,
        linkedAccountId: "384224417642",
        linkedAccountName: "Platform Service",
        payerAccountId: "632721170710",
        productCode: "AmazonEC2",
        productName: "EC2",
        platformName: "Linux/Unix",
        instanceFamily: "m5",
        instanceType: "m5.xlarge",
        regionCode: "ap-northeast-1",
        regionName: "Asia Pacific (Tokyo)",
        instanceSize: "xlarge",
        normalizationFactor: 8,
        tenancy: "Shared"
      }
    ]
  },
  totalSummary: {
    onDemandCost: 0.0,
    savingsPlansCost: 0.0,
    reservedOnDemandCost: 0.0,
    totalCost: 0.0,
    onDemandUsage: 0.0,
    reservedUsage: 0.0,
    savingsPlansUsage: 0.0,
    totalUsage: 0.0,
    totalUsageWithSp: 0.0,
    reservedCoverage: 0.0,
    reservedCoverageWithSp: 0.0,
    onDemandNfUsage: 0.0,
    reservedNfUsage: 0.0,
    savingsPlansNfUsage: 0.0,
    totalNfUsage: 0.0,
    totalNfUsageWithSp: 0.0,
    reservedNfCoverage: 0.0,
    reservedNfCoverageWithSp: 0.0
  },
  transition: [
    {
      onDemandCost: 0.0,
      savingsPlansCost: 0.0,
      reservedOnDemandCost: 0.0,
      totalCost: 0.0,
      onDemandUsage: 0.0,
      reservedUsage: 0.0,
      savingsPlansUsage: 0.0,
      totalUsage: 0.0,
      totalUsageWithSp: 0.0,
      reservedCoverage: 0.0,
      reservedCoverageWithSp: 0.0,
      onDemandNfUsage: 0.0,
      reservedNfUsage: 0.0,
      savingsPlansNfUsage: 0.0,
      totalNfUsage: 0.0,
      totalNfUsageWithSp: 0.0,
      reservedNfCoverage: 0.0,
      reservedNfCoverageWithSp: 0.0,
      usageDate: "2020-08-01"
    }
  ],
  selectedVendor: VENDOR_NAMES.AWS,
  selectedViewByOption: '',
  isFilterLoading: true,
  isTotalSummaryLoading: true,
  isCoverageListLoading: true,
  isTransitionLoading: true
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/reserved/coverage/index.js